var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { attrs: { id: "properties-container" } },
    [
      _c(
        "div",
        { staticClass: "bg-white shadow overflow-hidden rounded-lg mt-0" },
        [
          _c("div", { staticClass: "px-2 py-2 md:px-4 md:py-5 bg-gray-100" }, [
            _c(
              "div",
              { staticClass: "text-base leading-6 font-medium text-gray-900" },
              [
                _vm._v(" Información general "),
                _vm.getSelectedElement.type === "folder"
                  ? _c("span", [_vm._v(" de la carpeta ")])
                  : _vm._e(),
                _vm.getSelectedElement.type === "file"
                  ? _c("span", [_vm._v(" del archivo ")])
                  : _vm._e(),
                _c("span", { staticClass: "font-bold" }, [
                  _vm._v(_vm._s(_vm.getSelectedElement.name))
                ]),
                _c("div", { staticClass: "identification" }, [
                  _vm._v("ID: " + _vm._s(_vm.getSelectedElement.id))
                ])
              ]
            )
          ]),
          _c("div", { staticClass: "border-t border-gray-200" }, [
            _c("div", { staticClass: "grid grid-cols-12 gap-5" }, [
              _c(
                "div",
                { staticClass: "col-span-12 lg:col-span-4 ml-0" },
                [
                  _c(
                    "vs-list",
                    { staticClass: "ml-0" },
                    [
                      _c("ChangeOwnerView"),
                      _vm.getSelectedElement.type === "file"
                        ? _c("div", { staticClass: "vs-list--item" }, [
                            _c("div", { staticClass: "list-titles" }, [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "vs-list--title cursor-pointer d-flex align-items-center",
                                  on: { click: _vm.activeVotationForm }
                                },
                                [
                                  _c("b-form-rating", {
                                    directives: [
                                      {
                                        name: "tooltip",
                                        rawName: "v-tooltip",
                                        value: "Promedio de las evaluaciones",
                                        expression:
                                          "'Promedio de las evaluaciones'"
                                      }
                                    ],
                                    staticClass: "p-0 h-3",
                                    attrs: {
                                      "no-border": "",
                                      id: "evaluation-form",
                                      stars: "5",
                                      inline: "",
                                      variant: "warning",
                                      size: "lg",
                                      readonly: true,
                                      precision: ""
                                    },
                                    model: {
                                      value: _vm.getSelectedElement.evaluation,
                                      callback: function($$v) {
                                        _vm.$set(
                                          _vm.getSelectedElement,
                                          "evaluation",
                                          $$v
                                        )
                                      },
                                      expression:
                                        "getSelectedElement.evaluation"
                                    }
                                  }),
                                  _c(
                                    "span",
                                    {
                                      directives: [
                                        {
                                          name: "tooltip",
                                          rawName: "v-tooltip",
                                          value: "Cantidad de evaluaciones",
                                          expression:
                                            "'Cantidad de evaluaciones'"
                                        }
                                      ],
                                      staticClass: "badge badge-warning ml-2"
                                    },
                                    [
                                      _vm._v(
                                        " " +
                                          _vm._s(
                                            _vm.getSelectedElement
                                              .totalEvaluations
                                          ) +
                                          " "
                                      )
                                    ]
                                  )
                                ],
                                1
                              ),
                              _c("div", { staticClass: "vs-list--subtitle" }, [
                                _c("span", [_vm._v("Evaluación")])
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("vs-list-item", {
                            attrs: { title: _vm.size, subtitle: "Tamaño" }
                          })
                        : _vm._e(),
                      _vm.getSelectedElement.type === "folder"
                        ? _c("vs-list-item", {
                            attrs: { title: "Carpeta", subtitle: "Tipo" }
                          })
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("vs-list-item", {
                            attrs: { title: "Documento", subtitle: "Tipo" }
                          })
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("div", { staticClass: "vs-list--item" }, [
                            _c("div", { staticClass: "list-titles" }, [
                              _c("div", { staticClass: "vs-list--title" }, [
                                _c(
                                  "span",
                                  [
                                    _c("font-awesome-icon", {
                                      class: _vm.publicationStateIcon(
                                        _vm.getSelectedElement
                                      ).classes,
                                      attrs: {
                                        icon: [
                                          "fas",
                                          _vm.publicationStateIcon(
                                            _vm.getSelectedElement
                                          ).icon
                                        ]
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.publicationStateIcon(
                                            _vm.getSelectedElement
                                          ).message
                                        ) +
                                        " "
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c("div", { staticClass: "vs-list--subtitle" }, [
                                _c("span", [_vm._v("Estado de publicación")])
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file" &&
                      _vm.getSelectedElement.isPublic
                        ? _c("vs-list-item", {
                            attrs: {
                              title: "Publico",
                              subtitle: "Tipo de acceso"
                            }
                          })
                        : _vm.getSelectedElement.type === "file"
                        ? _c("vs-list-item", {
                            attrs: {
                              title: "Privado",
                              subtitle: "Tipo de acceso"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-span-12 lg:col-span-4" },
                [
                  _c(
                    "vs-list",
                    [
                      _c("vs-list-item", {
                        attrs: {
                          title: _vm.getSelectedElement.name,
                          subtitle: "Nombre de elemento"
                        }
                      }),
                      _vm.getSelectedElement.type === "file"
                        ? _c("div", { staticClass: "vs-list--item" }, [
                            _c("div", { staticClass: "list-titles" }, [
                              _c("div", { staticClass: "vs-list--title" }, [
                                _vm.getSelectedElement.publicLink
                                  ? _c(
                                      "div",
                                      [
                                        _c(
                                          "a",
                                          {
                                            directives: [
                                              {
                                                name: "tooltip",
                                                rawName: "v-tooltip",
                                                value: "Descarga el archivo",
                                                expression:
                                                  "'Descarga el archivo'"
                                              }
                                            ],
                                            staticClass:
                                              "float-left lg:w-48 xl:w-48 truncate cursor-pointer public-link",
                                            attrs: {
                                              href:
                                                _vm.getSelectedElement
                                                  .publicLink,
                                              target: "_BLANK"
                                            }
                                          },
                                          [_vm._v(" Archivo público ")]
                                        ),
                                        _c("vs-icon", {
                                          directives: [
                                            {
                                              name: "tooltip",
                                              rawName: "v-tooltip",
                                              value:
                                                "Copiar link para compartir",
                                              expression:
                                                "'Copiar link para compartir'"
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:copy",
                                              value:
                                                _vm.getSelectedElement
                                                  .publicLink,
                                              expression:
                                                "getSelectedElement.publicLink",
                                              arg: "copy"
                                            },
                                            {
                                              name: "clipboard",
                                              rawName: "v-clipboard:success",
                                              value: _vm.onCopy,
                                              expression: "onCopy",
                                              arg: "success"
                                            }
                                          ],
                                          staticClass:
                                            "text-purple cursor-pointer align-top",
                                          class: {
                                            "animated pulse":
                                              _vm.copyIconClicked
                                          },
                                          attrs: {
                                            icon: "content_copy",
                                            size: "small"
                                          }
                                        })
                                      ],
                                      1
                                    )
                                  : _c("span", [_vm._v("--")])
                              ]),
                              _c("div", { staticClass: "vs-list--subtitle" }, [
                                _c("span", [_vm._v("URL")])
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("vs-list-item", {
                            attrs: {
                              title: _vm.getSelectedElement.mimeType || "--",
                              subtitle: "MIME Type"
                            }
                          })
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("vs-list-item", {
                            attrs: {
                              title: _vm.getSelectedElement.owner || "--",
                              subtitle: "Publicador"
                            }
                          })
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("vs-list-item", {
                            attrs: {
                              title:
                                _vm.getSelectedElement.internalVersion.toString() ||
                                "--",
                              subtitle: "Versión interna"
                            }
                          })
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              ),
              _c(
                "div",
                { staticClass: "col-span-12 lg:col-span-4" },
                [
                  _c(
                    "vs-list",
                    [
                      _vm.getSelectedElement.creationDate
                        ? _c("vs-list-item", {
                            attrs: {
                              title: _vm
                                .$moment(_vm.getSelectedElement.creationDate)
                                .format("LLLL"),
                              subtitle: "Fecha de creación"
                            }
                          })
                        : _c("vs-list-item", {
                            attrs: {
                              title: "--",
                              subtitle: "Fecha de creación"
                            }
                          }),
                      _vm.getSelectedElement.type === "file" &&
                      _vm.getSelectedElement.publicationDate
                        ? _c("vs-list-item", {
                            attrs: {
                              title: _vm
                                .$moment(_vm.getSelectedElement.publicationDate)
                                .format("LLLL"),
                              subtitle: "Fecha de publicación"
                            }
                          })
                        : _c("vs-list-item", {
                            attrs: {
                              title: "--",
                              subtitle: "Fecha de publicación"
                            }
                          }),
                      _vm.getSelectedElement.type === "file"
                        ? _c("vs-list-item", {
                            attrs: {
                              title:
                                _vm.getSelectedElement.externalVersion || "--",
                              subtitle: "Versión externa"
                            }
                          })
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("div", { staticClass: "vs-list--item" }, [
                            _c("div", { staticClass: "list-titles" }, [
                              _c("div", { staticClass: "vs-list--title" }, [
                                _c(
                                  "span",
                                  [
                                    _c("font-awesome-icon", {
                                      class: _vm.validityStateIcon(
                                        _vm.getSelectedElement
                                      ).classes,
                                      attrs: {
                                        icon: [
                                          "fas",
                                          _vm.validityStateIcon(
                                            _vm.getSelectedElement
                                          ).icon
                                        ]
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.validityStateIcon(
                                            _vm.getSelectedElement
                                          ).message
                                        ) +
                                        " "
                                    )
                                  ],
                                  1
                                ),
                                _vm.getSelectedElement.expirationDate
                                  ? _c(
                                      "span",
                                      { staticClass: "small text-muted" },
                                      [
                                        _vm._v(
                                          " (" +
                                            _vm._s(
                                              _vm.getSelectedElement
                                                .expirationDate
                                            ) +
                                            ") "
                                        )
                                      ]
                                    )
                                  : _vm._e()
                              ]),
                              _c("div", { staticClass: "vs-list--subtitle" }, [
                                _c("span", [_vm._v("Vencimiento")])
                              ])
                            ])
                          ])
                        : _vm._e(),
                      _vm.getSelectedElement.type === "file"
                        ? _c("div", { staticClass: "vs-list--item" }, [
                            _c("div", { staticClass: "list-titles" }, [
                              _c("div", { staticClass: "vs-list--title" }, [
                                _c(
                                  "span",
                                  [
                                    _c("font-awesome-icon", {
                                      class: _vm.approvalStateIcon(
                                        _vm.getSelectedElement
                                      ).classes,
                                      attrs: {
                                        icon: [
                                          "fas",
                                          _vm.approvalStateIcon(
                                            _vm.getSelectedElement
                                          ).icon
                                        ]
                                      }
                                    }),
                                    _vm._v(
                                      " " +
                                        _vm._s(
                                          _vm.approvalStateIcon(
                                            _vm.getSelectedElement
                                          ).message
                                        ) +
                                        " "
                                    )
                                  ],
                                  1
                                )
                              ]),
                              _c("div", { staticClass: "vs-list--subtitle" }, [
                                _c("span", [_vm._v("Estado de aprobación")])
                              ])
                            ])
                          ])
                        : _vm._e()
                    ],
                    1
                  )
                ],
                1
              )
            ])
          ])
        ]
      ),
      _c("EDTagsForm"),
      _c("EDKeywordsForm"),
      _c("EvaluationForm")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }